const QuickLinksBanner = ({
                            titleChild, title, subtitle,
                            imageChild, imageUrl,
                            bgClass = "bg-tertiary",
                            pdClass
                          }) => {

  return (
    <div className={`w-full app-top-mg bg-none ${pdClass ?? 'app-side-pd'}`}>
      <div className="h-24 flex items-end">
        <div className={`app-rounded shadow ${bgClass} relative w-full`}>
          {/*<div className="bg-error-500 py-3 pl-3 pr-5 rounded-r-full mr-3 rounded-l-lg">*/}
          {/*  kjkj*/}
          {/*</div>*/}
          {imageChild ??
          <img src={imageUrl} className="absolute bottom-0 h-16 -left-2" alt="image" style={{height: "94px"}}/>}

          <div className="flex flex-col text-white leading-1 space-y-1 py-3 text-xs h-16 justify-center">
            {titleChild ?? <div className="font-black pl-28">{title}</div>}
            {!!subtitle && <div className="text-xs pl-28">{subtitle}</div>}
          </div>

        </div>
      </div>

    </div>
  );
};

export default QuickLinksBanner;

export const BloodRequestBanner = ({pdClass}) =>
  <QuickLinksBanner pdClass={pdClass} titleChild={<div className="font-bold pl-28">Donate or Request Blood</div>}
                    imageChild={<img src="/images/blood_request.png" className="absolute bottom-0 left-0"
                                     style={{height: "94px"}}
                                     alt="image"/>}/>;

export const CustomerCareBanner = ({pdClass}) =>
  <QuickLinksBanner title="Customer Care" bgClass="gradient-primary" imageUrl="/images/customer_service.png" pdClass={pdClass}
                    subtitle="Contact for Order Status"/>;

export const BloodGlucoseBanner = ({pdClass}) =>
  <QuickLinksBanner title="Manage Blood Glucose" pdClass={pdClass}
                    imageChild={<img src="/images/blood_glucose.png" className="absolute bottom-0 -left-px"
                                     style={{height: "94px"}} alt="image"/>}
                    subtitle={<img src="/images/contour_device.png" className=""
                                   style={{width: "100px"}} alt="image"/>}/>;

export const PhonePharmacistBanner = ({pdClass}) =>
  <QuickLinksBanner titleChild={<div className="font-black pl-10 ml-7">Phone<br/>Pharmacist</div>}
                    pdClass={pdClass}
                    imageChild={<img src="/images/connect_pharmacist.png" className="absolute bottom-0 left-0"
                                     style={{height: "94px"}} alt="image"/>}/>;

export const UploadPrescriptionBanner = ({pdClass}) =>
  <QuickLinksBanner titleChild={<div className="font-black whitespace-pre-wrap pl-10 ml-8">Upload Your<br/>Prescription</div>} pdClass={pdClass}
                    imageChild={<img src="/images/upload_prescription.png" className="absolute bottom-0 left-0 rounded"
                                     style={{height: "94px"}} alt="image"/>}/>;